import $ from 'jquery';

App.registerBehavior('PreviewWindowClose', function (appSettings) {
  $('[data-preview-close]').once('PreviewWindowClose').each(function () {
    $(this).on('click', function (e) {
      // Note: This is inspired by https://stackoverflow.com/a/16580022/1439093
      // Try to go back ...
      window.history.back();
      // ... and in case that was not possible, close the window/tab
      window.close();
    });
  });
});